import PropTypes from 'prop-types';
import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';

import Colors from '../../constants/Colors';
import Svg from '../Svg';

import { AppText } from '../AppText';

const styles = StyleSheet.create({
  optionContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  optionLabel: {
    marginLeft: 10,
    color: Colors.grayText,
  },
});

/**
 * A checkbox-based multiselect component. This is a 'controlled' component -
 * it does not maintain selection state internally, but derives the state from
 * the passed in options (option.selected)
 *
 * options: Array<{ value: unknown, label: string, selected: boolean }>
 * onSelectionChanged : (selectedValues: Array<typeof option.value>) => void
 */
function MultiSelect(props) {
  const { options, onSelectionChanged } = props;
  const selectedValues = options.filter((option) => option.selected).map((option) => option.value);

  const toggleOption = (optionValue) => {
    if (selectedValues.includes(optionValue)) {
      onSelectionChanged(selectedValues.filter((value) => value !== optionValue));
      return;
    }

    onSelectionChanged([optionValue, ...selectedValues]);
    return;
  };

  return (
    <React.Fragment>
      {options.map(({ value, label, selected }) => {
        return (
          <TouchableOpacity
            key={`FilterItem-${value}`}
            style={styles.optionContainer}
            onPress={() => toggleOption(value)}
          >
            <Svg icon={selected ? 'square_checked' : 'square_unchecked'} color={Colors.primaryColor} />
            <AppText style={styles.optionLabel}>{label}</AppText>
          </TouchableOpacity>
        );
      })}
    </React.Fragment>
  );
}

MultiSelect.propTypes = {
  options: PropTypes.array.isRequired,
  onSelectionChanged: PropTypes.func.isRequired,
};

export default MultiSelect;
